import { render, staticRenderFns } from "./AuditLogPaginate.vue?vue&type=template&id=1298143c&scoped=true&"
import script from "./AuditLogPaginate.vue?vue&type=script&lang=js&"
export * from "./AuditLogPaginate.vue?vue&type=script&lang=js&"
import style0 from "./AuditLogPaginate.vue?vue&type=style&index=0&id=1298143c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1298143c",
  null
  
)

export default component.exports